import { Table } from '@tanstack/react-table'

export const TableColGroup = <T,>({ table }: { table: Table<T> }) => {
    const headers = table.getHeaderGroups()[0]?.headers ?? []
    return (
        <colgroup>
            {headers.map((header) => (
                <col
                    key={header.id}
                    style={{
                        width: header.column.columnDef.meta?.width ?? 'var(--size-64)',
                        maxWidth: header.column.columnDef.meta?.maxWidth,
                    }}
                />
            ))}
        </colgroup>
    )
}
